
import Vue from "vue";
import AppPaymentMethods from "@/components/account/PaymentMethods.vue";

export default Vue.extend({
	components: {
		AppPaymentMethods
	}
});
